import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocationDropdown from './location-dropdown';
import { FormattedMessage, injectIntl } from 'react-intl';

class LocationWrapper extends Component {
  constructor (props) {
    super(props);

    this.state = {
      error: {}
    };
    this.isValid = this.isValid.bind(this);
    this.errorFn = this.errorFn.bind(this);
  }

  isValid () {
    const { location } = this.props;
    let errorFree = true;

    if (!location) { errorFree = false; }

    this.errorFn();
    return errorFree;
  }

  getValue () {
    const { location } = this.props;
    return location;
  }

  errorFn (hasLocation) {
    const { location } = this.props;
    let error = this.invalidState();
    if (location || hasLocation) {
      error = this.validState();
    }
    this.setState({ error });
  }

  checkForError () {
    const { error } = this.state;

    if (error.errorMsg) {
      return (
        <p className={"help-block inline-help text-danger text-left"}>{error.errorMsg}</p>
      );
    }

    return null;
  }

  validState () {
    const errorObj = {};
    errorObj.inputBorder = null;
    errorObj.errorMsg = null;
    errorObj.errorIcon = null;
    errorObj.validIcon = true;
    return errorObj;
  }

  invalidState () {
    const errorObj = {};
    errorObj.inputBorder = 'error';
    errorObj.errorMsg = this.props.intl.formatMessage({ id: 'boards.location_wrapper.enter_location', defaultMessage: 'Please enter a valid location' });
    errorObj.errorIcon = true;
    errorObj.validIcon = null;
    return errorObj;
  }

  render () {
    const { error } = this.state;
    return (
      <div className='form-group has-feedback location-search text-left'>
        <label htmlFor='location' className='control-label vert-align-label'>
          <FormattedMessage
            id='boards.location_wrapper.save_space'
            defaultMessage='Location'
          />
        </label>
        <LocationDropdown
          ref='location-dropdown'
          {...this.props}
          errorFn={this.errorFn}
          error={error}
        />
        {this.checkForError()}
      </div>
    );
  }
}

LocationWrapper.propTypes = {
  location: PropTypes.string
};

exports.LocationWrapper = injectIntl(LocationWrapper, { withRef: true });
